import TabSwitcher from 'components/TabSwitcher';
import classNames from 'styles/utils/classNames';
import type { ForYouScope } from './useForYouScope';

const SCOPE_OPTIONS = [
  { label: 'All', value: 'all' as const },
  { label: 'For you', value: 'forYou' as const },
];

interface Props {
  scope: ForYouScope;
  onScopeChange: (scope: ForYouScope) => void;
  className?: string;
}

/** The brand-filled "All / For you" switch (Figma "Switch"). */
export default function ForYouSwitch({ scope, onScopeChange, className }: Props) {
  return (
    <TabSwitcher
      options={SCOPE_OPTIONS}
      selectedValue={scope}
      onValueChange={onScopeChange}
      activeFillBrand
      wrapperClassName={classNames(
        'shadow-[inset_0_1px_2px_0_rgba(0,0,0,0.16)] max-lg:h-8 max-lg:w-[8.375rem] lg:h-[2.625rem] lg:w-[13.125rem]',
        className,
      )}
    />
  );
}
